import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { shared } from './shared';
import { soundEngine } from '../audio/soundEngine';

// Visible splash ring + spatial 'thud' whenever a whale breaches.
export default function WhaleFX() {
  const ring = useRef();
  const mat = useRef();
  const st = useRef({ seq: 0, t: 999, x: 0, z: 0 });

  useFrame((_, delta) => {
    const s = st.current;
    if (shared.breachSeq !== s.seq) {
      s.seq = shared.breachSeq;
      s.t = 0; s.x = shared.breachX; s.z = shared.breachZ;
      try { soundEngine.playThud(s.x, 0, s.z); } catch (e) {}
    }
    s.t += delta;
    if (!ring.current) return;
    const active = s.t < 1.7;
    ring.current.visible = active;
    if (active) {
      const sc = 2 + s.t * 18;
      ring.current.position.set(s.x, 0.15, s.z);
      ring.current.scale.set(sc, sc, sc);
      if (mat.current) mat.current.opacity = Math.max(0, 0.7 * (1 - s.t / 1.7));
    }
  });

  return (
    <mesh ref={ring} rotation={[-Math.PI / 2, 0, 0]} visible={false}>
      <ringGeometry args={[0.72, 1, 40]} />
      <meshBasicMaterial ref={mat} color="#dbeafe" transparent opacity={0.7} depthWrite={false} side={THREE.DoubleSide} />
    </mesh>
  );
}
